var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { Button } from "./Button";
import { Flexbox } from "./Box";
import { Text } from "./Text";
export var AlertType;
(function (AlertType) {
    AlertType["Info"] = "info";
    AlertType["Success"] = "success";
    AlertType["Error"] = "error";
})(AlertType || (AlertType = {}));
var colorScheme = (_a = {},
    _a[AlertType.Info] = {
        alert: "#094771",
        button: "#4077aa",
    },
    _a[AlertType.Success] = {
        alert: "#088A68",
        button: "#04b486",
    },
    _a[AlertType.Error] = {
        alert: "#903636",
        button: "#f14c4c",
    },
    _a);
export var Alert = function (_a) {
    var message = _a.message, type = _a.type, onClose = _a.onClose;
    var bg = colorScheme[type || AlertType.Info];
    return message ? (_jsx(_Fragment, { children: ReactDOM.createPortal(_jsxs(Flexbox, __assign({ flexFlow: "column nowrap", justifyContent: "space-between", position: "fixed", bottom: 2, right: 2, maxWidth: "35%", minWidth: "300px", minHeight: "100px", padding: 2, alignItems: "start", backgroundColor: bg === null || bg === void 0 ? void 0 : bg.alert, color: "#fff", zIndex: 1500 }, { children: [_jsx(Text, __assign({ padding: 2 }, { children: _jsx("pre", __assign({ style: { whiteSpace: "break-spaces" } }, { children: message })) })), _jsx(Button, __assign({ width: "50px", alignSelf: "flex-end", py: 1, px: 2, backgroundColor: bg === null || bg === void 0 ? void 0 : bg.button, color: "white", onClick: onClose }, { children: "Close" }))] })), document.body) })) : null;
};
//# sourceMappingURL=Alert.js.map